<template>
  <div>
    <el-carousel height="14rem" v-show="imgUrlList.length> 0">
      <el-carousel-item v-for="(item,i) in imgUrlList" :key="i">
        <el-image fit="cover" :src="item" :preview-src-list="imgUrlList">
        </el-image>
      </el-carousel-item>
    </el-carousel>
    <el-carousel height="14rem" v-show="imgUrlList.length <= 0">
      <el-carousel-item>
        <el-image fit="cover" :src="common.imgUrl()+common.baseImg()">
        </el-image>
      </el-carousel-item>
    </el-carousel>
  </div>

  <!-- common.baseImg() -->
</template>

<script>
export default {
  name: "ImgList",
  props: {
    imgUrl: String,
  },
  data() {
    return {
      imgUrlList: [],
    };
  },
  watch: {
    imgUrl(newVal, oldVal) {
      if (newVal) {
        this.imgUrlList = [];
        let imgUrl = this.common.imgUrl();
        let imgArr = newVal.split("#");
        for (let i = 0; i < imgArr.length; i++) {
          let item = imgUrl + imgArr[i];
          this.imgUrlList.push(item);
        }
      } else {
        this.imgUrlList = [];
      }
    },
  },
  mounted() {},
  methods: {},
};
</script>
<style scoped lang="scss">
.el-image {
  // width: 100%;
  // height: 100%;
}
</style>
